import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const PaymentSuccessful = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    return (
        <div className="h-full  p-14 lg:w-3/4">
            <h1 className="text-2xl font-semibold">
                {t("payment_successful.title")}
            </h1>
            <div className="flex flex-col justify-between h-[95%]">
                <div className="mt-4 ">
                    <p>{t("payment_successful.description")}</p>
                    <p>{t("payment_successful.description_2")}</p>

                    <button
                        onClick={() => navigate("/login")}
                        className="btn btn-sm mt-4"
                    >
                        {t("payment_successful.go_to_login")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PaymentSuccessful;
